// AI generated
import type { CSSProperties, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

/** The floating white surface shared by the node, group and edge toolbars. */
export function FlowToolbar({
  children,
  className,
  style,
}: {
  children: ReactNode
  className?: string
  style?: CSSProperties
}) {
  return (
    <div
      className={twMerge(
        'flex flex-row items-center justify-between gap-1 rounded-md bg-white p-2 shadow-md',
        className,
      )}
      style={style}
    >
      {children}
    </div>
  )
}
